import styled from "styled-components";

import backArrowIcon from "../../../../assets/Mayo/back_arrow_blue.svg";
import { useNavigate } from "react-router-dom";

export default function Back({style}) {
  const navigate = useNavigate();

  return (
    <Container
      onClick={() => navigate(-1)}
      style={style}
    >
      <Icon 
        src={backArrowIcon}
      />
      <Text>Back</Text>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  gap: 18px;
  margin-left: 26px;
  align-items: center;
`

const Icon = styled.img`
  width: 16px;
  height: 16px;
  display: block;
`

const Text = styled.p`
  margin: 0;
  font-size: 17px;
  font-weight: 500;
  color: #7A9DFD;
`